import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-20 px-4" data-id="element-114">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628] via-[#1a2744] to-[#0a1628] z-0" data-id="element-115" />

      {/* Gold Glow Effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#d4a843] rounded-full mix-blend-overlay filter blur-[128px] opacity-20 animate-pulse" data-id="element-116" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#b8922e] rounded-full mix-blend-overlay filter blur-[128px] opacity-20" data-id="element-117" />

      <div className="max-w-7xl mx-auto w-full relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-118">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="inline-block px-4 py-1 border border-[#d4a843]/50 rounded-full text-[#d4a843] text-sm tracking-widest uppercase mb-6 bg-[#0a1628]/50 backdrop-blur-sm" data-id="element-120">
            Edición Limitada 2026
          </motion.div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-121">
            El Método <br data-id="element-122" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a843] via-[#e8c66a] to-[#d4a843]" data-id="element-123">
              Ingreso Invisible
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 font-light leading-relaxed" data-id="element-124">
            Cómo Generar{' '}
            <span className="text-[#e8c66a] font-semibold" data-id="element-125">$10,000 MXN</span>{' '}
            Extras al Mes Sin Mostrar tu Cara ni Vender a tus Amigos.
          </p>

          <div className="p-6 border-l-2 border-[#d4a843] bg-[#243352]/30 backdrop-blur-sm mb-8 text-left" data-id="element-126">
            <p className="text-lg text-gray-200 italic font-serif" data-id="element-127">
              "La guía definitiva de Arbitraje de Contenido Faceless para
              mujeres que valoran su privacidad."
            </p>
          </div>

          <p className="text-xs text-gray-500 max-w-md mx-auto lg:mx-0" data-id="element-128">
            Disclaimer: Este material es para fines educativos. Los resultados
            dependen de la ejecución constante. No somos asesores financieros.
          </p>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        rotate: -5
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 flex justify-center" data-id="element-129">
          <div className="relative" data-id="element-130">
            <div className="absolute inset-0 bg-[#d4a843] rounded-full filter blur-[60px] opacity-20" data-id="element-131" />
            <motion.img animate={{
            y: [0, -20, 0]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/3W26dFEzvMidkX4UTtmANr/INGRESO_INVISIBLE.png" alt="El Método Ingreso Invisible en dispositivos digitales" className="relative z-10 w-full max-w-md lg:max-w-lg drop-shadow-2xl" data-id="element-132" />
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center" data-id="element-133">
        <span className="text-[#d4a843] text-xs tracking-widest uppercase mb-2" data-id="element-134">
          Descubre el método
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-[#d4a843] to-transparent" data-id="element-135" />
      </motion.div>
    </section>;
}